import { motion } from "framer-motion";
import { useGame } from "../../context/GameContext.jsx";
import { ROLE_DATA } from "../../data/roles.js";
import { RoleBadge } from "./RoleBadge.jsx";

export function CatalogModal({ roleId, onClose }) {
  const { state } = useGame();
  const lang = state.language;
  const t = (fr, en) => lang === "fr" ? fr : en;
  const role = ROLE_DATA[roleId];
  if (!role) return null;

  const alignLabel = {
    village:  t("Village","Village"),
    werewolf: t("Loup-Garou","Werewolf"),
    neutral:  t("Neutre","Neutral"),
  }[role.alignment] || t("Mixte","Mixed");

  const alignDesc = {
    village:  t("Le Village gagne en éliminant toutes les menaces.","The Village wins by eliminating every threat to the village."),
    werewolf: t("Les Loups gagnent quand ils égalent ou dépassent tous les adversaires restants.","The Werewolves win once they equal or outnumber all remaining opponents."),
    neutral:  t("Ce rôle a son propre objectif personnel et gagne indépendamment.","This role has its own personal objective and wins independently."),
  }[role.alignment] || t("L'alignement de ce rôle peut changer selon les événements.","This role may change allegiance during the game depending on events.");

  return (
    <motion.div
      initial={{ opacity:0 }} animate={{ opacity:1 }} exit={{ opacity:0 }}
      className="fixed inset-0 z-[9999] flex items-center justify-center px-6"
      style={{ background:"rgba(0,0,0,0.85)" }}
      onClick={onClose}>
      <motion.div
        initial={{ opacity:0, y:40, scale:0.9 }}
        animate={{ opacity:1, y:0, scale:1, transition:{ type:"spring", stiffness:260, damping:22 } }}
        exit={{ opacity:0, y:30, scale:0.92 }}
        onClick={e => e.stopPropagation()}
        className={`w-full max-w-xs relative rounded-3xl border-2 ${role.border}
          bg-gradient-to-b ${role.gradient} overflow-hidden shadow-2xl`}>
        <button onClick={onClose}
          className="absolute top-3 right-3 z-20 w-8 h-8 rounded-full bg-black/60
            text-white/90 flex items-center justify-center text-sm active:scale-95 border border-white/10">✕</button>

        <div className="w-full aspect-[3/4] bg-black/30 flex items-center justify-center relative">
          {role.imageUrl
            ? <img src={role.imageUrl} alt={role.englishName} className="w-full h-full object-cover" />
            : <span className="text-8xl select-none">{role.emoji}</span>}
          {role.roleBadge && (
            <div className="absolute top-2 left-2 z-10">
              <RoleBadge roleBadge={role.roleBadge} lang={lang} />
            </div>
          )}
          <span className={`absolute bottom-2 right-2 text-[10px] font-bold px-2 py-0.5
            rounded-full ${role.badge} text-white/90 border border-white/10`}>
            {alignLabel}
          </span>
        </div>

        <div className="px-4 pt-3 pb-5">
          <h3 className="text-white font-bold text-xl leading-tight">{lang === "fr" ? role.frenchName : role.englishName}</h3>
          <p className="text-white/70 text-sm mt-2 leading-relaxed">{lang === "fr" ? role.frenchDescription : role.englishDescription}</p>
          <div className="mt-3 pt-3 border-t border-white/10">
            <p className="text-white/40 text-[10px] uppercase tracking-widest mb-1">{t("Objectif","Objective")}</p>
            <p className="text-amber-300 text-xs font-semibold">🎯 {lang === "fr" ? role.frenchObjective : role.englishObjective}</p>
          </div>
          <div className="mt-3 pt-3 border-t border-white/10">
            <p className="text-white/40 text-[10px] uppercase tracking-widest mb-1">{t("Camp","Camp")}</p>
            <p className="text-white/60 text-xs leading-relaxed">{alignDesc}</p>
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
}
